import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { EmployeesAvatarGroup } from '../../../../../../atomic/molecules/EmployeesAvatarGroup/EmployeeAvatarGroup';
import { ApprovalRequest } from '../../../../pages/Absences/MyAbsences/MyAbsenceFilters/types';
import './styles.css';

type Props = {
  approvalRequests: ApprovalRequest[];
};

export const ApprovalAvatars: React.FC<React.PropsWithChildren<Props>> = ({
  approvalRequests,
}) => {
  const tForAbsences = useNamespacedTranslation('absences');
  const { t } = useTranslation();

  const filteredRequests = approvalRequests.filter((req) => req.approver);

  if (filteredRequests.length === 0) return null;

  const recipients = filteredRequests.map((req) => ({
    type: 'employee' as const,
    id: req.approver.id,
    employee: {
      id: req.approver.id,
      name: req.approver.name,
      initials: `${req.approver.firstName?.[0] || ''}${
        req.approver.lastName?.[0] || ''
      }`,
      avatarUrl: req.approver.avatar.url ?? null,
      department: '',
    },
  }));

  const tooltipContent = (
    <div className="text-start">
      {filteredRequests.map((req) => {
        const status = tForAbsences(
          `status.${req.approvalStatus.toLowerCase()}`,
        );
        const date = req.lastModifiedDate
          ? moment(req.lastModifiedDate).format(t(`dateTime.short`))
          : '';

        return (
          <div key={req.id} className="mb-1">
            <div>{req.approver?.name}</div>
            <div className="text-muted small">
              {status} • {date}
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="d-flex align-items-center gap-2 ps-3">
      <OverlayTrigger
        overlay={
          <Tooltip
            id={`tooltip-${filteredRequests[0].id}`}
            className="tooltip-wide">
            {tooltipContent}
          </Tooltip>
        }
        placement="left">
        <div>
          <EmployeesAvatarGroup
            recipients={recipients}
            maxAvatarsToShow={3}
            avatarSize="xs"
            gapSize={20}
            hideHint={true}
          />
        </div>
      </OverlayTrigger>
    </div>
  );
};
